import { render } from "./AnchorParser.vue?vue&type=template&id=6d12ba12"
import script from "./AnchorParser.vue?vue&type=script&lang=js"
export * from "./AnchorParser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__